<template>
    <div class="mb-4 w-[50%] space-y-4 text-center lg:mb-6 z-10">
        <h3 class="text-center text-base leading-[23px] md:text-2xl md:leading-[33px]" v-html="formattedTitle"></h3>
        <p class="text-[14px] font-light md:text-[16px]">
            {{ item?.subtitle }}
        </p>
        <div class="flex justify-center">
            <Button
                v-if="item?.button?.title"
                :title="item.button.title"
                :link="url"
                :buttonType="item.button.type"
                :type="item.button.type"
                class="w-max"
                classes="!px-10 !py-3.5 font-semibold"></Button>
        </div>
    </div>
</template>

<script setup lang="ts">
    defineProps<{
        item: any;
        formattedTitle: string;
        url: string;
    }>();
</script>
